<template>
 <section>
        <el-dialog
  :title="storeLanguage=='en'?'Data Import':'数据导入'"
  visible
  width="75%"
 :fullscreen="true"
  :before-close="modalClose">  
  <div class="icon-content w-100  " style="overflow-y: hidden;" :style="{height:'calc(100vh - 180px)'}">
 <el-form ref="form"  style="width: 100%!important;"  label-width="80px">
	<el-form-item label="">
	  <div class="tip m-0"><p><span class="text-required   relative" >{{text}}</span>数据导入上传Excel后表格中带有<span class="text-required f18  relative" style="top:5px">*</span>必填
	 <el-link v-if="describe" @click="getDescribe" type="primary">，点击此处查看导入说明。</el-link> </p></div>
	</el-form-item>
	 <el-form-item  label="添加模板">
		  <div class="w-50">
	  <el-input    placeholder="请填写模板名称" v-model="templateName"  >
		  	 <template v-if="status==1" slot="prepend"><i  class="el-icon-close"  @click="statusClick"></i></template>
	     <el-button  type="primary" slot="append" @click="templateNameClick" icon="el-icon-check"></el-button>
	   </el-input></div>
	 </el-form-item>
	 <el-form-item v-show="status==1" label="模板内容">
		 <el-table
		   :data="columnList"
		    class="import-table"
		   highlight-current-row
		 		ref="multipleTable"
		   style="width: 48%;float: left;"
		   @select-all="selectAllChange"
		   @select="selectChange"
		   :height="height-467"
		 >
		  <template slot="empty">
		 		  <el-empty description="暂时没有数据"></el-empty>
		 </template>
		  <el-table-column
		       type="selection"
		       >
		     </el-table-column>
		 	<el-table-column
		 	      type="index" label="行号"
		 	      width="50">
		 	    </el-table-column>
		 <el-table-column  prop='props' label='字段' >
		 	<template  slot="header" slot-scope="scope">
		 				<el-input  size="mini"  clearable  @clear="clearClick"    placeholder="搜索字段" v-model="name"  >
		 				   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
		 				 </el-input>
		 		      </template>
		 			 <template slot-scope="scope"><div style="line-height: 32px;">{{scope.row.props}}</div> </template>
		 </el-table-column>
		  	<el-table-column   prop='columnName' label='标题' >
		 		<template  slot="header" slot-scope="scope">
		 					<el-input   size="mini" clearable @clear="clearClick" placeholder="搜索标题" v-model="title"  >
		 					   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
		 					 </el-input>
		 			      </template>
		 	</el-table-column>
		 </el-table>
		 
		 
		 <el-table
		    :data="oklist"
		    highlight-current-row
			class="import-table"
		    style="width: 48%;"
		    :height="height-467"
		  >
		   <template slot="empty">
		  		  <el-empty description="暂时没有数据"></el-empty>
		  </template>
		  <!-- <el-table-column
		        type="selection"
		        >
		      </el-table-column> -->
		  	<el-table-column
		  	      type="index" label="行号"
		  	      width="50">
		  	    </el-table-column>
		  <el-table-column  prop='props' label='列字段名' ></el-table-column>
		  	<!-- <el-table-column   prop='columnName' label='标题' ></el-table-column> -->
		  	<el-table-column   prop='asName' label='Excel标题' >
		 		 <template slot-scope="scope"><el-input v-model="scope.row.asName"></el-input> </template>
		 	</el-table-column> 		
		 	<!-- <el-table-column   prop='orders' label='排序' >
		 		 <template slot-scope="scope"><el-input type="number"  v-model="scope.row.orders"></el-input> </template>
		 	</el-table-column> 		 -->
		 <el-table-column label="操作">
		 			  <template  slot-scope="scope">
		 				   <el-button  @click="okcolumnDeleteClick(scope)" type="text" size="small">删除</el-button>
		 			  </template>
		 </el-table-column>
		  </el-table>
	 </el-form-item>
	 <el-form-item v-if="templateList.length>0&&status==0" label="现有模板">
	   <el-radio-group @change="templateChange" v-model="templateId">
	     <el-radio  v-for="item in templateList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
	   </el-radio-group>
	  
	 </el-form-item>
	 <el-form-item v-if="templateList.length>0&&templateId&&status==0" label="上传excel">
	   <com-form-uploaders :limit="1"@callbackList="callbackList" format="file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" className="className"></com-form-uploaders>
	 </el-form-item>
	 <el-form-item v-show="importList.length>0&&templateId&&status==0" label="确认数据">
	   <el-table class="import-table"
	   ref="multipleTableRef"
	      :data="list"
	    highlight-current-row
	      style="width: 100%;"
		  :height="height-689"
	    >
		
			<el-table-column
			:fixed="'left'"
			      type="index" label="行号"
			      width="50">
			    </el-table-column>
		  <el-table-column width="200" v-for="(item,i) in importList"   >
			  <template slot="header" slot-scope="scope">
				  <p style="height: inherit;padding: 0;margin: 0;" :class="item.required?'table-required':''">{{item.asName}}</p>
				   <p style="height: inherit;padding: 0;margin: 0;" >{{(i+1)}}</p>
			  </template>
		  			   <!-- <template slot-scope="scope">
							 <com-form-uploaders v-if="item.columnName.indexOf('图')>-1" :isShow="false" format="button" @callbackList="callbackImageList" :index="scope.$index" :limit="1" :list="scope.row.imgurl"> </com-form-uploaders>
		  					   <el-input   v-else-if="!item.columnType"  v-model="scope.row[item.props]"></el-input>
							   <el-select  size="mini" v-else-if="item.columnName.indexOf('是否')>-1" v-model="scope.row[item.props]" placeholder="请选择">
							       <el-option
							         v-for="item in optionsList"
							         :key="item.value"
							         :label="item.label"
							         :value="item.value">
							       </el-option>
							     </el-select>
							   <el-input v-else-if="item.columnType=='nvarchar'||!item.columnType"  v-model="scope.row[item.props]"></el-input>
							   <el-input v-else-if="item.columnType=='int'||item.columnType=='decimal'" min="-1" type="number"  v-model="scope.row[item.props]"></el-input>
							   <el-date-picker  v-else-if="item.columnType=='datetime'"
									v-model="scope.row[item.props]"
									prefix-icon="213"
							         type="date" 
									 value-format="yyyy-MM-dd"
							         placeholder="">
							       </el-date-picker>
								   <el-select v-else-if="item.columnType=='bool'"  size="mini" v-model="scope.row[item.props]" placeholder="请选择">
								       <el-option
								         v-for="item in options"
								         :key="item.value"
								         :label="item.label"
								         :value="item.value">
								       </el-option>
								     </el-select>
		  			    </template> -->
						<!-- <template slot-scope="scope">
							 <el-input v-if="item.columnType=='int'||item.columnType=='decimal'" min="-1" type="number"  v-model="scope.row[item.props]"></el-input>
							   <el-input v-else="item.columnType=='nvarchar'||!item.columnType"  v-model="scope.row[item.props]"></el-input>
							  
							  
						</template> -->
		  </el-table-column>
		  <el-table-column width="160" :fixed="'right'" label="操作">
			  <template  slot="header" slot-scope="scope">
				  <el-divider   direction="vertical"></el-divider>
				  <el-link :underline="false"   @click="getTemplateClick" class="text-success">下载模板</el-link>
				  <el-divider direction="vertical"></el-divider>  
				  <el-link :underline="false" @click="deleteTemplateClick"  class="text-danger">删除模板</el-link>
			
			  						
			  	      </template>
			  <template  slot-scope="scope">
				   <el-button  @click="deleteClick(scope)" type="text" size="small">删除</el-button>
			  </template>
		  </el-table-column>
	    </el-table>
	 </el-form-item>
	
	 </el-form>
          </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="modalClose">{{$t("dialog.cancel")}}</el-button>
    <el-button type="primary" @click="okClick">{{status==0?'导入':'确定'}}</el-button>
  </span>
</el-dialog> 

</section>
	  </template>
<script>
	  export default {
		      props: {
				limit: {
					type: Number,
					default: 3000
				},
				text: {
					type: String,
					default: ''
				},
				describe: {
					type: String,
					default: ''
				},
				isUpdate: {
					type: Boolean,
					default: false
				},
				},
	    data() {
	      return {
			  name:'',
			  title:'',
			   options: [{
			            value: true,
			            label: '是'
			          }, {
			            value: false,
			            label: '否'
			          }],
					  optionsList: [{
					           value: '是',
					           label: '是'
					         }, {
					           value: '否',
					           label: '否'
					         }],
			  list:[],
			  oklist:[],
			  currentFile:'',
			  templateId:'',
			  templateList:[],
			  templateName:'',
			  columnList:[],
			    sourceList:[],
			  status:0,
			   height:window.screen.height,
			   importList:[],
			   notifys:''
			 }
	    },
		mounted(){
			this.getTemplateColumnsQuery();
		},
	    methods: {
			getDescribe(){
				this.notifys= this.$notify({
				          title: '导入说明',
				          message: this.describe,
						    dangerouslyUseHTMLString: true,
				          duration: 0
				        });
			},
			clearClick(){
					this.columnList=this.sourceList;
				
				},
			searchClick(scope){
				let list=this.sourceList;
				if(this.name){
					list=list.filter(item=>item.props.indexOf(this.name)>-1)
				}
				if(this.title){
					list=list.filter(item=>item.columnName.indexOf(this.title)>-1)
				}
				this.columnList=list;
			     
				
			},
			getTemplateClick(){
				this.$confirm("您确认要下载此模板吗", "操作提示", {
					type: 'info'
				}).then(() => {
					let asName="";
					var obj= this.templateList.find(item=>item.id==this.templateId);
					asName=obj.columnList.map(item=>item.asName).join(',');
					this.$axios.get(`/api/Excel/GetExcelTemplate`,{params:{templateName:obj.name,columnName:asName}}).then(e=>{
					window.location.href=this.$domain+e;
					})
				})
			},
			selectAllChange(selection){
			let list=selection;
			if(list.length==0){
			   this.columnList.forEach(item=>{
				  let index=this.oklist.findIndex(items=>item.props==items.props);
				  if(index>-1){
				  this.oklist.splice(index,1)}
			   })
			}else{
				list.forEach((item,i)=>{
									  let index=this.oklist.findIndex(items=>item.props==items.props);
									  if(index==-1){
									  this.oklist.push(list[i])}
				})
			}
				this.oklist.map((item,i)=>item.orders=(i+1))
			},
			selectChange(selection,row){
		    let selected=selection.length>0&&selection.findIndex(item=>item.props==row.props)>-1?true:false;
		    let index=this.oklist.findIndex(item=>item.props==row.props);
		     if(index>-1&&!selected){
		     this.oklist.splice(index,1)}
		     else if(index==-1&&selected){
		      this.oklist.push(row)}
		    this.oklist.map((item,i)=>item.orders=(i+1));
			// let selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
			// var index=this.columnList.findIndex(item=>{return item.props==row.props});
			// if(index==0||this.columnList[index].orders==selection.length){return}
			// 	this.columnList[index].orders=selected?selection.length:index+1;
			// 	if(selected){
			// 		this.columnList[this.columnList[index].orders-1].orders=index+1;
			// 		this.columnList.sort((a, b) => a.orders- b.orders)
			// 	}
				
			},
			deleteTemplateClick(){
				this.$confirm("您确认要删除此模板吗", "操作提示", {
					type: 'warning'
				}).then(() => {
					
					this.$axios.post(`/api/Template/PostTemplateDelete` , JSON.stringify(this.templateId.toString())).then(e => {
						 this.$message.success('删除成功到同步服务器');
						 let index=this.templateList.findIndex(item=>item.id==this.templateId);
						 this.templateList.splice(index,1);
								this.templateId='';
					  }); 
				}).catch(() => {});
			},
			getTemplateColumnsQuery(){
				var data={params:{roleId:this.$store.state.user.roleId}};
				data.params.tableName=this.$route.fullPath.substring(1,this.$route.fullPath.length);
				data.params.menuName=data.params.tableName.split('?')[0];
				data.params.state=1;
				this.$axios.get(`/api/Template/GetTemplateColumnsQuery`,data).then(e=>{
					this.templateList=e;
				})
			},
			templateChange(e){
				var obj=this.templateList.find(item=>{return item.id==e});
				this.importList=[];
				if(obj.columnList){
					this.$setTimeout(300).then(s=>{
						this.importList=obj.columnList;
					})
					return;
				}
				this.$axios.get(`/api/Template/GetTemplateColumnsId`,{params:{id:obj.id}}).then(e=>{
					obj.columnList=e;
					this.importList=e;
				})
				
			},
			statusClick(){
				this.status=0;
				this.templateName='';
				
			},
			templateNameClick(){
				if(!this.$allSpace(this.templateName)){
					this.$message.error('请填写模板名称');return
				}
				if(this.templateList.filter(item=>item.name==this.templateName).length>0){
					this.$message.error('模板名称不能相同');return
				}
				this.status=1;
				this.$axios.get('/api/Columns/GetColumnsRoleQuery',{params:{roleId:this.$store.state.user.roleId,tableName:this.$route.fullPath.substring(1,this.$route.fullPath.length)}}).then(e => {
						if(e.length==0){
										  this.$message.warning(this.$store.state.menu.name+'没有配置列表信息');
									}
									e.map(item=>item.name=item.name.replace("*翻译", "").replace("*必填", ""));
									e.map(item=>item.columnName=item.name)
									e.map(item=>item.asName=item.columnName)
										e.map(item=>item.columnType=item.dataType)
										
									this.columnList=e;
									  this.sourceList=e;
				  });
			},
			callbackImageList(e){
				this.list[e.index].imgurl=e.list.join();
			},
			modalClose(e){
			if(this.notifys)	this.notifys.close();
				  this.$store.commit("saveOperate", "");
			},
		deleteClick(e){
			this.list.splice(e.$index,1)
		},
			okClick(){
				if(this.status==1){
					this.templateFunc();
				}else{
					this.templateExcelFunc();
				}
			if(this.notifys)	this.notifys.close();
			},
			templateExcelFunc(){
				if(this.list.length==0) {this.$message.error('Excel没有要导入的记录');return}
				let list=this.list;
				let importList=this.importList;
				for (let i = 0; i < importList.length; i++) {
					for (let j = 0; j < list.length; j++) {
						if(importList[i].required&&!list[j][importList[i].props]&&importList[i].columnType!="int"&&importList[i].columnType!="decimal"){
							this.$message.error('请填写第'+(j+1)+"行第"+(i+1)+"列");return;
						}
					}
				}
				var tableName=this.$route.fullPath.substring(1,this.$route.fullPath.length).split('?')[0];
				if(this.isUpdate){
					this.$axios.post(`/api/${tableName}/Post${tableName}ExcelListUpdate`,{list:list,props:importList.map(item=>item.props).join(',')}).then(e=>{
					})
				}else{
					let obj= this.templateList.find(item=>item.id==this.templateId);
					let asName=obj.columnList.map(item=>item.asName).join(',');
					let props=obj.columnList.map(item=>item.props).join(',')
					let data={list:list,columnName:asName,columnSource:props};
					this.$axios.post(`/api/${tableName}/Post${tableName}ExcelList`,data).then(e=>{
						if(e.data.length>0){
							this.$message.error('数据效验不通过');
							localStorage.setItem('error',e.data);
							this.$notify({
							         title: '提示',
							         message:e.data,
							         type: 'error',
									    dangerouslyUseHTMLString: true,
															   duration: 0
							       });
									  	// window.open(location.origin+this.$paths+'/error','_blank');
							return;
						}
						this.$message.success('数据导入成功');
						 this.$store.commit("saveOperate", "");
						 this.$emit("callbackImport","");  
					})
				}
				
			},
			templateFunc(){
				let list=	this.oklist;
				if(list.length==0){this.$message.warning('请勾选条目');return;}
					for (let j = 0; j < list.length; j++) {
						
						var index=list.findIndex(item=>item.props==list[j].props)
						if(index==-1){
							continue;
						}
						 if(!list[j].asName){
						 	this.$message.error('请填写第'+(j+1)+"行Excel标题");return;
						 }
						//  if(!list[j].orders||list[j].orders<0){
						// 	this.$message.error('第'+(j+1)+"行的排序必须大于0");return;
						// }
					}
					// var tag=new Set(list.map(item=>item.asName)).size != list.length;
					// if(tag){this.$message.warning('有重复的Excel标题');return;}
					var data={roleId:this.$store.state.user.roleId};
					data.tableName=this.$route.fullPath.substring(1,this.$route.fullPath.length);
					data.menuName=data.tableName.split('?')[0];
					data.state=1;
					data.name=this.templateName;
					data.columnList=list;
					this.$axios.post(`/api/Template/PostTemplateAppend`,data).then(e=>{
						this.getTemplateColumnsQuery();
						this.templateName='';
						this.status=0;
					})
			},
			columnDeleteClick(e){
				this.columnList.splice(e.$index,1)
			},
			okcolumnDeleteClick(e){
				this.oklist.splice(e.$index,1)
			},
		callbackList(e) {
			console.log(e)
			if(e.length==0) {this.list=[]; return;}
			let asName="";
			let props="";
		var obj= this.templateList.find(item=>item.id==this.templateId);
		asName=obj.columnList.map(item=>item.asName).join(',');
		props=obj.columnList.map(item=>item.props).join(',')
			this.currentFile=e.join();
			// let data={params:{fileName:e.join(),columnName:asName,columnSource:props}};
			let data={fileName:e.join(),columnName:asName,columnSource:props};
		// this.$axios.get(`/api/Excel/GetExcelData?fileName=`+e.join()+'&columnName='+asName+'&columnSource='+props).then(e => {
			this.$axios.post(`/api/Excel/postExcelData`,data).then(e => {
			if(e.data.length==0){this.$message.error('Excel没有要导入的记录');return} 
			if(e.data.length>this.limit){this.$message.error('Excel导入限制在'+this.limit+'条记录内');return}
			let list=e.data;
			let importList=this.importList;
			// for (let i = 0; i < importList.length; i++) {
			// 	for (let j = 0; j < list.length; j++) {
			// 		if((importList[i].columnType=="int"||importList[i].columnType=="decimal")&& isNaN(Number(list[j][importList[i].props]))){
			// 			list[j][importList[i].props]=1;
			// 		}
			// 		if(importList[i].columnType=="datetime"&&list[j][importList[i].props]&&(list[j][importList[i].props].indexOf('-')==-1||list[j][importList[i].props].indexOf('/')==-1)){
			// 			list[j][importList[i].props]=list[j][importList[i].props].replace(/-/g,"-");
			// 		}
			// 	}
			// }
			this.list=list;
			  });
		    
		},
		getTemplate(){
			let name=this.$store.state.menu.name;
			window.location.href=this.$domain+'/Excel/ExcelTemplate/'+name+'.xlsx';
		}
		},computed: {
    storeLanguage() {
      return this.$store.state.language;
    },
    
  }
	  }
</script>

<style >
	.import-table th{
		padding: 6px 0px!important;
	}
	.table-required{
		position: relative;
	}
	.text-required{
		color: #ea644a;
	}
	.table-required:after {
	    position: absolute;
	    display: inline-block;
	    font-size: 30px;
	    color: #ea644a;
		top:3px;
	    content: '*';
	}
</style>
